module.exports = __webpack_public_path__ + "static/media/41331c3c-3759-4462-8695-33c9a21b6a5b.be40fb3b.woff2";